import { casesOf, type OrderItem, OrderItemSchema, unitsOf } from '../../../../data/order-item';
import type { Product } from '../../../../data/product';

export type ProductOrderItem = {
  product: Product;
  suggested_cases?: number;
  cases?: number;
  suggested_units?: number;
  units?: number;
  // Set by the server alongside the suggested quantities. Absent on a catalog
  // row that has no order item at all, and on a draft written before the field
  // shipped — reorderLabel falls back for both.
  suggestion_reason?: string;
};

export function itemHasCount(orderItem: ProductOrderItem): boolean {
  return casesOf(orderItem) > 0 || unitsOf(orderItem) > 0;
}

export function itemHasOnlyUnits(orderItem: ProductOrderItem): boolean {
  return casesOf(orderItem) === 0 && unitsOf(orderItem) > 0;
}

export function itemHasUserCount(orderItem: ProductOrderItem): boolean {
  return orderItem.cases !== undefined || orderItem.units !== undefined;
}

// Narrows a ProductOrderItem (full Product, editor-local fields) down to the
// OrderItem the API takes: the product is reduced to ProductInfo's nine fields
// and unknown keys are dropped, which z.object() does by default.
//
// This validates as well as strips, where Yup's .cast() only stripped. The
// quantities are declared .int(), matching the Go side, where all four are
// `int` bound with ShouldBindJSON (lambdas/api/models/orders.go:63-67) — a
// fractional quantity is a 400 there. Nothing produces one today, so a throw
// here means a new fractional source upstream.
export function simplifyOrderItem(orderItem: ProductOrderItem): OrderItem {
  return OrderItemSchema.parse(orderItem);
}
